// extracted by mini-css-extract-plugin
export default {"title":"_08e3aa8e44","inner_title":"_400abf6780","charge_btn":"c1a1ec9792"};